import { Link } from "react-router-dom";

export interface Crumb {
  label: string;
  to?: string;
}

interface BreadcrumbsProps {
  items: Crumb[];
}

export default function Breadcrumbs({ items }: BreadcrumbsProps) {
  return (
    <nav aria-label="面包屑导航" className="text-xs md:text-sm font-label">
      <ol className="flex flex-wrap items-center gap-x-2 gap-y-1 text-foreground-500">
        <li className="flex items-center gap-1.5">
          <Link
            to="/"
            className="transition-colors hover:text-primary-600 cursor-pointer whitespace-nowrap"
          >
            首页
          </Link>
        </li>
        {items.map((item) => (
          <li key={item.label} className="flex items-center gap-2">
            <span aria-hidden="true" className="text-foreground-300">
              /
            </span>
            {item.to ? (
              <Link
                to={item.to}
                className="transition-colors hover:text-primary-600 cursor-pointer whitespace-nowrap"
              >
                {item.label}
              </Link>
            ) : (
              <span className="text-foreground-800 whitespace-nowrap" aria-current="page">
                {item.label}
              </span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}